export default "https://cdn-static.gokick.com/assets/ecb6814e4f4fd856ee5e2a82e5f087b2e6d90ad2/images/spearmint-flavor.30903ab4672f84579e06d9b02d9a9cc8.png";